import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { captureException } from '@sentry/react';
import { computeItemCountsByLocation } from '@/components/CycleCounts/utils';
import { CYCLE_COUNT_BY_PK, CYCLE_COUNT_WAREHOUSE_ITEMS } from './graphql/queries';

export function useCycleCountDetails(cycleCountId) {
    const { data: countData, loading: countLoading } = useQuery(CYCLE_COUNT_BY_PK, {
        variables: { cycle_count_id: cycleCountId },
        skip: !cycleCountId,
        fetchPolicy: 'cache-and-network',
        onError: (error) => captureException(error),
    });

    const cycleCount = countData?.cycle_counts_by_pk;
    const warehouseId = cycleCount?.warehouse_id;

    const { data: itemsData, loading: itemsLoading } = useQuery(CYCLE_COUNT_WAREHOUSE_ITEMS, {
        variables: { warehouse_id: warehouseId },
        skip: !warehouseId,
        fetchPolicy: 'cache-and-network',
        onError: (error) => captureException(error),
    });

    const itemCountsByLocation = useMemo(
        () => computeItemCountsByLocation(cycleCount, itemsData?.items),
        [cycleCount, itemsData?.items]
    );

    return {
        cycleCount,
        itemCountsByLocation,
        loading: countLoading || (warehouseId && itemsLoading),
    };
}
